import { TagInput } from '@common/components/TagInput';

export interface DeliveryEmailInputProps {
    emails: string[];
    onEmailsChange: (emails: string[]) => void;
    placeholder: string;
    suggestedEmails?: string[];
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const DeliveryEmailInput = ({
    emails,
    onEmailsChange,
    placeholder,
    suggestedEmails = [],
}: DeliveryEmailInputProps) => {
    return (
        <TagInput
            tags={emails}
            onChange={onEmailsChange}
            options={{
                placeholder,
                suggestions: suggestedEmails,
                validate: (email) => EMAIL_REGEX.test(email),
                submitKeys: ['Enter', ' ', ',', ';'],
                separators: [' ', ',', ';', '\n'],
            }}
        />
    );
};
